// firmware versions components
const Firmware = () => import("Modules/configuration/firmware_versions/views/Firmware");

export default {
    children: [
        {
            path: "configuration/firmware",
            name: "firmware_versions",
            component: Firmware,
            meta: {
                requiresAuth: true,
                title: "lang.firmware",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
